import { Checkbox, RadioGroup } from "@nextui-org/react"
import { Radio } from "antd";
import { toLocaleStringConverter } from "../../../helper/Converters";

const PaymentInstallements = ({ installments, setInstallmentPeriod, installmentPeriod }) => {

    return <div className={`bg-white border border-[#E3E8EF] rounded-[5px] duration-300`}>
        <div className="border-b border-[#E3E8EF] p-[20px]">Taksit Seçenekleri</div>
        <div className="border border-[#E3E8EF] bg-white rounded-[5px] overflow-hidden m-[20px]">
            <div className="flex flex-col">
                <RadioGroup name="installment">

                    {installments?.map((defaultInstallment) => {
                        return <Radio

                            style={{ borderBottom: "1px solid #E3E8EF", backgroundColor: installmentPeriod === defaultInstallment?.installmentPeriod ? "#f7f5ff" : "white" }}
                            checked={installmentPeriod === defaultInstallment?.installmentPeriod}
                            onChange={() => { setInstallmentPeriod(defaultInstallment?.installmentPeriod) }}
                            buttonSolidCheckedColor="#7059ef"
                            className="px-[30px] py-[20px] hover:!bg-[#f7f5ff] hover:!bg-opacity-30 duration-500 mr-0 relative" >
                            <div className="flex flex-row flex-1 absolute w-[calc(100%-100px)] top-[50%] translate-y-[-50%] text-[14px] text-gray-800 font-medium gap-[7px]">
                                {defaultInstallment?.installmentPeriod == 1 ? "Tek Çekim" : `${defaultInstallment?.installmentPeriod} Taksit `}
                                {defaultInstallment?.installmentPeriod != 1 &&

                                    <span className="text-gray-500 font-medium">

                                        {`  (${defaultInstallment?.currencySymbol} ${toLocaleStringConverter(defaultInstallment?.installmentPrice, undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`}
                                    </span>
                                }
                                <span className="ml-auto left-0 top-0 font-medium text-gray-600">

                                    {defaultInstallment?.currencySymbol} {toLocaleStringConverter(defaultInstallment?.installmentFinalizedPaymentAmount, undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                            </div>

                        </Radio>
                    })}
                </RadioGroup>

            </div>
        </div>
    </div>


}

export default PaymentInstallements